/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseDashboardViewTypeResponse,
  DashboardHideOrUnHideRequestBody,
  DashboardNameResponse,
  DashboardShareGroupWithUserResponse,
  DashboardStartScreenIdsResponse,
  DashboardStartScreenRequest,
  GetV8DashboardsDashboardParams,
  GetV8DashboardsFeaturedDashboardsByDashboardName200,
  GetV8DashboardsFeaturedDashboardsParams,
  GetV8DashboardsGroupsWithUsersParams,
  GetV8DashboardsParams,
  GetV8DashboardsStartScreenParams,
  IntegrateDashboardShareDeleteV8Request,
  IntegrateDashboardSharePatchV8Request,
  IntegrateDashboardSharedDeleteV8Request,
  IntegrateDashboardV8FeaturedResponse,
  IntegrateDashboardV8Response,
  IntegratedDashboardV8RecentSharedResponse,
  IntegratedDashboardV8RecentVisitResponse,
  IntegratedDashboardV8Response,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 대시보드 리스트(피처드 제외) - 25.01 대시보드 목록 개선 새로운 버전
 */
export const getV8Dashboards = (
  params?: MaybeRef<GetV8DashboardsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<IntegratedDashboardV8Response>(
    { url: `/api/v8/dashboards`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsQueryKey = (params?: MaybeRef<GetV8DashboardsParams>) => {
  return ['api', 'v8', 'dashboards', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8Dashboards>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8Dashboards>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8Dashboards>>> = ({ signal }) =>
    getV8Dashboards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8Dashboards>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsQueryResult = NonNullable<Awaited<ReturnType<typeof getV8Dashboards>>>;
export type GetV8DashboardsQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 리스트(피처드 제외) - 25.01 대시보드 목록 개선 새로운 버전
 */

export function useGetV8Dashboards<
  TData = Awaited<ReturnType<typeof getV8Dashboards>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8Dashboards>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 리스트 - permission 필드 제거 & sharing 필드 추가  25.01.15) getCustomBoardsNew 로 대체 예정
 */
export const getV8DashboardsDashboard = (
  params?: MaybeRef<GetV8DashboardsDashboardParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<IntegrateDashboardV8Response>(
    { url: `/api/v8/dashboards/dashboard`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsDashboardQueryKey = (
  params?: MaybeRef<GetV8DashboardsDashboardParams>,
) => {
  return ['api', 'v8', 'dashboards', 'dashboard', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsDashboardParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsDashboard>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsDashboard>>> = ({
    signal,
  }) => getV8DashboardsDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsDashboard>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsDashboard>>
>;
export type GetV8DashboardsDashboardQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 리스트 - permission 필드 제거 & sharing 필드 추가  25.01.15) getCustomBoardsNew 로 대체 예정
 */

export function useGetV8DashboardsDashboard<
  TData = Awaited<ReturnType<typeof getV8DashboardsDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsDashboardParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsDashboard>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 startScreen 설정
 */
export const patchV8DashboardsDashboardStartScreen = (
  dashboardStartScreenRequest: MaybeRef<DashboardStartScreenRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  dashboardStartScreenRequest = unref(dashboardStartScreenRequest);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/dashboard/start-screen`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardStartScreenRequest,
    },
    options,
  );
};

export const getPatchV8DashboardsDashboardStartScreenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>,
    TError,
    { data: BodyType<DashboardStartScreenRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>,
  TError,
  { data: BodyType<DashboardStartScreenRequest> },
  TContext
> => {
  const mutationKey = ['patchV8DashboardsDashboardStartScreen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>,
    { data: BodyType<DashboardStartScreenRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV8DashboardsDashboardStartScreen(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8DashboardsDashboardStartScreenMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>
>;
export type PatchV8DashboardsDashboardStartScreenMutationBody =
  BodyType<DashboardStartScreenRequest>;
export type PatchV8DashboardsDashboardStartScreenMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 startScreen 설정
 */
export const usePatchV8DashboardsDashboardStartScreen = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>,
      TError,
      { data: BodyType<DashboardStartScreenRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardStartScreen>>,
  TError,
  { data: BodyType<DashboardStartScreenRequest> },
  TContext
> => {
  const mutationOptions = getPatchV8DashboardsDashboardStartScreenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 공유 - 사용자 추가
 */
export const patchV8DashboardsDashboardUserShare = (
  integrateDashboardSharePatchV8Request: MaybeRef<IntegrateDashboardSharePatchV8Request>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  integrateDashboardSharePatchV8Request = unref(integrateDashboardSharePatchV8Request);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/dashboard/user-share`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardSharePatchV8Request,
    },
    options,
  );
};

export const getPatchV8DashboardsDashboardUserShareMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>,
    TError,
    { data: BodyType<IntegrateDashboardSharePatchV8Request> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>,
  TError,
  { data: BodyType<IntegrateDashboardSharePatchV8Request> },
  TContext
> => {
  const mutationKey = ['patchV8DashboardsDashboardUserShare'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>,
    { data: BodyType<IntegrateDashboardSharePatchV8Request> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV8DashboardsDashboardUserShare(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8DashboardsDashboardUserShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>
>;
export type PatchV8DashboardsDashboardUserShareMutationBody =
  BodyType<IntegrateDashboardSharePatchV8Request>;
export type PatchV8DashboardsDashboardUserShareMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 공유 - 사용자 추가
 */
export const usePatchV8DashboardsDashboardUserShare = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>,
      TError,
      { data: BodyType<IntegrateDashboardSharePatchV8Request> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserShare>>,
  TError,
  { data: BodyType<IntegrateDashboardSharePatchV8Request> },
  TContext
> => {
  const mutationOptions = getPatchV8DashboardsDashboardUserShareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 공유 - 목록에서 삭제(공유받은 경우 내 목록에서 unshare)
 */
export const patchV8DashboardsDashboardUserSharedUnshare = (
  integrateDashboardSharedDeleteV8Request: MaybeRef<IntegrateDashboardSharedDeleteV8Request>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  integrateDashboardSharedDeleteV8Request = unref(integrateDashboardSharedDeleteV8Request);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/dashboard/user-shared/unshare`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardSharedDeleteV8Request,
    },
    options,
  );
};

export const getPatchV8DashboardsDashboardUserSharedUnshareMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>,
    TError,
    { data: BodyType<IntegrateDashboardSharedDeleteV8Request> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>,
  TError,
  { data: BodyType<IntegrateDashboardSharedDeleteV8Request> },
  TContext
> => {
  const mutationKey = ['patchV8DashboardsDashboardUserSharedUnshare'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>,
    { data: BodyType<IntegrateDashboardSharedDeleteV8Request> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV8DashboardsDashboardUserSharedUnshare(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8DashboardsDashboardUserSharedUnshareMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>
>;
export type PatchV8DashboardsDashboardUserSharedUnshareMutationBody =
  BodyType<IntegrateDashboardSharedDeleteV8Request>;
export type PatchV8DashboardsDashboardUserSharedUnshareMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 공유 - 목록에서 삭제(공유받은 경우 내 목록에서 unshare)
 */
export const usePatchV8DashboardsDashboardUserSharedUnshare = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>,
      TError,
      { data: BodyType<IntegrateDashboardSharedDeleteV8Request> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharedUnshare>>,
  TError,
  { data: BodyType<IntegrateDashboardSharedDeleteV8Request> },
  TContext
> => {
  const mutationOptions = getPatchV8DashboardsDashboardUserSharedUnshareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 공유 - 공유 해제(내가 공유한 대시보드)
 */
export const patchV8DashboardsDashboardUserSharingUnsharingByDashboardId = (
  dashboardId: MaybeRef<number>,
  integrateDashboardShareDeleteV8Request: MaybeRef<IntegrateDashboardShareDeleteV8Request>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  dashboardId = unref(dashboardId);
  integrateDashboardShareDeleteV8Request = unref(integrateDashboardShareDeleteV8Request);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/dashboard/${dashboardId}/user-sharing/unsharing`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardShareDeleteV8Request,
    },
    options,
  );
};

export const getPatchV8DashboardsDashboardUserSharingUnsharingByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>,
    TError,
    { dashboardId: number; data: BodyType<IntegrateDashboardShareDeleteV8Request> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<IntegrateDashboardShareDeleteV8Request> },
  TContext
> => {
  const mutationKey = ['patchV8DashboardsDashboardUserSharingUnsharingByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>,
    { dashboardId: number; data: BodyType<IntegrateDashboardShareDeleteV8Request> }
  > = (props) => {
    const { dashboardId, data } = props ?? {};

    return patchV8DashboardsDashboardUserSharingUnsharingByDashboardId(
      dashboardId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8DashboardsDashboardUserSharingUnsharingByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>
>;
export type PatchV8DashboardsDashboardUserSharingUnsharingByDashboardIdMutationBody =
  BodyType<IntegrateDashboardShareDeleteV8Request>;
export type PatchV8DashboardsDashboardUserSharingUnsharingByDashboardIdMutationError =
  ErrorType<unknown>;

/**
 * @summary 대시보드 공유 - 공유 해제(내가 공유한 대시보드)
 */
export const usePatchV8DashboardsDashboardUserSharingUnsharingByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>,
      TError,
      { dashboardId: number; data: BodyType<IntegrateDashboardShareDeleteV8Request> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8DashboardsDashboardUserSharingUnsharingByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<IntegrateDashboardShareDeleteV8Request> },
  TContext
> => {
  const mutationOptions =
    getPatchV8DashboardsDashboardUserSharingUnsharingByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 방문 이력 추가
 */
export const postV8DashboardsDashboardVisitByDashboardId = (
  dashboardId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);

  return customAxiosInstance<boolean>(
    { url: `/api/v8/dashboards/dashboard/${dashboardId}/visit`, method: 'POST', signal },
    options,
  );
};

export const getPostV8DashboardsDashboardVisitByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>,
    TError,
    { dashboardId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>,
  TError,
  { dashboardId: number },
  TContext
> => {
  const mutationKey = ['postV8DashboardsDashboardVisitByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>,
    { dashboardId: number }
  > = (props) => {
    const { dashboardId } = props ?? {};

    return postV8DashboardsDashboardVisitByDashboardId(dashboardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsDashboardVisitByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>
>;

export type PostV8DashboardsDashboardVisitByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 방문 이력 추가
 */
export const usePostV8DashboardsDashboardVisitByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>,
      TError,
      { dashboardId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsDashboardVisitByDashboardId>>,
  TError,
  { dashboardId: number },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsDashboardVisitByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 리스트 - 피처드 대시보드
 */
export const getV8DashboardsFeaturedDashboards = (
  params: MaybeRef<GetV8DashboardsFeaturedDashboardsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<IntegrateDashboardV8FeaturedResponse>(
    { url: `/api/v8/dashboards/featured-dashboards`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsFeaturedDashboardsQueryKey = (
  params?: MaybeRef<GetV8DashboardsFeaturedDashboardsParams>,
) => {
  return ['api', 'v8', 'dashboards', 'featured-dashboards', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsFeaturedDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsFeaturedDashboardsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsFeaturedDashboardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>> = ({
    signal,
  }) => getV8DashboardsFeaturedDashboards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsFeaturedDashboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>
>;
export type GetV8DashboardsFeaturedDashboardsQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 리스트 - 피처드 대시보드
 */

export function useGetV8DashboardsFeaturedDashboards<
  TData = Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsFeaturedDashboardsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsFeaturedDashboardsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 이름으로 피처드 대시보드 id 조회
 */
export const getV8DashboardsFeaturedDashboardsByDashboardName = (
  dashboardName: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardName = unref(dashboardName);

  return customAxiosInstance<GetV8DashboardsFeaturedDashboardsByDashboardName200>(
    { url: `/api/v8/dashboards/featured-dashboards/${dashboardName}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsFeaturedDashboardsByDashboardNameQueryKey = (
  dashboardName?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'dashboards', 'featured-dashboards', dashboardName] as const;
};

export const getGetV8DashboardsFeaturedDashboardsByDashboardNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>,
  TError = ErrorType<unknown>,
>(
  dashboardName: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsFeaturedDashboardsByDashboardNameQueryKey(dashboardName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>
  > = ({ signal }) =>
    getV8DashboardsFeaturedDashboardsByDashboardName(dashboardName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(dashboardName)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsFeaturedDashboardsByDashboardNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>
>;
export type GetV8DashboardsFeaturedDashboardsByDashboardNameQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 이름으로 피처드 대시보드 id 조회
 */

export function useGetV8DashboardsFeaturedDashboardsByDashboardName<
  TData = Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>,
  TError = ErrorType<unknown>,
>(
  dashboardName: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsFeaturedDashboardsByDashboardName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsFeaturedDashboardsByDashboardNameQueryOptions(
    dashboardName,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스에서 연계할 대시보드 선택 리스트 (Database > 인스턴스 클릭 시 Information > Instance Name 옆 설정 버튼 > Go to Dashboard 리스트)
피처드 대시보드 포함 이름만 내려줌
 */
export const getV8DashboardsGotoDashboardList = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<DashboardNameResponse>(
    { url: `/api/v8/dashboards/goto-dashboard-list`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsGotoDashboardListQueryKey = () => {
  return ['api', 'v8', 'dashboards', 'goto-dashboard-list'] as const;
};

export const getGetV8DashboardsGotoDashboardListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsGotoDashboardListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>> = ({
    signal,
  }) => getV8DashboardsGotoDashboardList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsGotoDashboardListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>
>;
export type GetV8DashboardsGotoDashboardListQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스에서 연계할 대시보드 선택 리스트 (Database > 인스턴스 클릭 시 Information > Instance Name 옆 설정 버튼 > Go to Dashboard 리스트)
피처드 대시보드 포함 이름만 내려줌
 */

export function useGetV8DashboardsGotoDashboardList<
  TData = Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsGotoDashboardList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsGotoDashboardListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 공유 - 그룹, 사용자 리스트
 */
export const getV8DashboardsGroupsWithUsers = (
  params?: MaybeRef<GetV8DashboardsGroupsWithUsersParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DashboardShareGroupWithUserResponse>(
    { url: `/api/v8/dashboards/groups-with-users`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsGroupsWithUsersQueryKey = (
  params?: MaybeRef<GetV8DashboardsGroupsWithUsersParams>,
) => {
  return ['api', 'v8', 'dashboards', 'groups-with-users', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsGroupsWithUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsGroupsWithUsersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsGroupsWithUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>> = ({
    signal,
  }) => getV8DashboardsGroupsWithUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsGroupsWithUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>
>;
export type GetV8DashboardsGroupsWithUsersQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 공유 - 그룹, 사용자 리스트
 */

export function useGetV8DashboardsGroupsWithUsers<
  TData = Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsGroupsWithUsersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsGroupsWithUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsGroupsWithUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 피처드 대시보드 숨김 - master 전용
 */
export const postV8DashboardsHide = (
  dashboardHideOrUnHideRequestBody: MaybeRef<DashboardHideOrUnHideRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardHideOrUnHideRequestBody = unref(dashboardHideOrUnHideRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/hide`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardHideOrUnHideRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsHideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsHide>>,
    TError,
    { data: BodyType<DashboardHideOrUnHideRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsHide>>,
  TError,
  { data: BodyType<DashboardHideOrUnHideRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8DashboardsHide'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsHide>>,
    { data: BodyType<DashboardHideOrUnHideRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8DashboardsHide(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsHideMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsHide>>
>;
export type PostV8DashboardsHideMutationBody = BodyType<DashboardHideOrUnHideRequestBody>;
export type PostV8DashboardsHideMutationError = ErrorType<unknown>;

/**
 * @summary 피처드 대시보드 숨김 - master 전용
 */
export const usePostV8DashboardsHide = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsHide>>,
      TError,
      { data: BodyType<DashboardHideOrUnHideRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsHide>>,
  TError,
  { data: BodyType<DashboardHideOrUnHideRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsHideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 리스트 - 최근 공유받은 대시보드
 */
export const getV8DashboardsRecentSharedDashboards = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<IntegratedDashboardV8RecentSharedResponse>(
    { url: `/api/v8/dashboards/recent-shared-dashboards`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsRecentSharedDashboardsQueryKey = () => {
  return ['api', 'v8', 'dashboards', 'recent-shared-dashboards'] as const;
};

export const getGetV8DashboardsRecentSharedDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsRecentSharedDashboardsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>
  > = ({ signal }) => getV8DashboardsRecentSharedDashboards(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsRecentSharedDashboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>
>;
export type GetV8DashboardsRecentSharedDashboardsQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 리스트 - 최근 공유받은 대시보드
 */

export function useGetV8DashboardsRecentSharedDashboards<
  TData = Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsRecentSharedDashboards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsRecentSharedDashboardsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 리스트 - 최근 방문 대시보드
 */
export const getV8DashboardsRecentVisitDashboards = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<IntegratedDashboardV8RecentVisitResponse>(
    { url: `/api/v8/dashboards/recent-visit-dashboards`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsRecentVisitDashboardsQueryKey = () => {
  return ['api', 'v8', 'dashboards', 'recent-visit-dashboards'] as const;
};

export const getGetV8DashboardsRecentVisitDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsRecentVisitDashboardsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>
  > = ({ signal }) => getV8DashboardsRecentVisitDashboards(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsRecentVisitDashboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>
>;
export type GetV8DashboardsRecentVisitDashboardsQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 리스트 - 최근 방문 대시보드
 */

export function useGetV8DashboardsRecentVisitDashboards<
  TData = Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsRecentVisitDashboards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsRecentVisitDashboardsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary startScreen 설정되어 있는 대시보드 조회 : 피처드 대시보드 숨김 시 확인 팝업 띄우는 용도
 */
export const getV8DashboardsStartScreen = (
  params: MaybeRef<GetV8DashboardsStartScreenParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DashboardStartScreenIdsResponse>(
    { url: `/api/v8/dashboards/start-screen`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsStartScreenQueryKey = (
  params?: MaybeRef<GetV8DashboardsStartScreenParams>,
) => {
  return ['api', 'v8', 'dashboards', 'start-screen', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsStartScreenQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsStartScreen>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsStartScreenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsStartScreen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsStartScreenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsStartScreen>>> = ({
    signal,
  }) => getV8DashboardsStartScreen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsStartScreen>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsStartScreenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsStartScreen>>
>;
export type GetV8DashboardsStartScreenQueryError = ErrorType<unknown>;

/**
 * @summary startScreen 설정되어 있는 대시보드 조회 : 피처드 대시보드 숨김 시 확인 팝업 띄우는 용도
 */

export function useGetV8DashboardsStartScreen<
  TData = Awaited<ReturnType<typeof getV8DashboardsStartScreen>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsStartScreenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsStartScreen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsStartScreenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 피처드 대시보드 숨김 해제 - master 전용
 */
export const postV8DashboardsUnhide = (
  dashboardHideOrUnHideRequestBody: MaybeRef<DashboardHideOrUnHideRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardHideOrUnHideRequestBody = unref(dashboardHideOrUnHideRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/unhide`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardHideOrUnHideRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsUnhideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsUnhide>>,
    TError,
    { data: BodyType<DashboardHideOrUnHideRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsUnhide>>,
  TError,
  { data: BodyType<DashboardHideOrUnHideRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8DashboardsUnhide'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsUnhide>>,
    { data: BodyType<DashboardHideOrUnHideRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8DashboardsUnhide(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsUnhideMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsUnhide>>
>;
export type PostV8DashboardsUnhideMutationBody = BodyType<DashboardHideOrUnHideRequestBody>;
export type PostV8DashboardsUnhideMutationError = ErrorType<unknown>;

/**
 * @summary 피처드 대시보드 숨김 해제 - master 전용
 */
export const usePostV8DashboardsUnhide = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsUnhide>>,
      TError,
      { data: BodyType<DashboardHideOrUnHideRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsUnhide>>,
  TError,
  { data: BodyType<DashboardHideOrUnHideRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsUnhideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 기본뷰, 멀티뷰로 사용될 대시보드 아이디 조회
 */
export const getV8DashboardsViewTypeDashboards = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseDashboardViewTypeResponse>(
    { url: `/api/v8/dashboards/view-type-dashboards`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsViewTypeDashboardsQueryKey = () => {
  return ['api', 'v8', 'dashboards', 'view-type-dashboards'] as const;
};

export const getGetV8DashboardsViewTypeDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsViewTypeDashboardsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>> = ({
    signal,
  }) => getV8DashboardsViewTypeDashboards(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsViewTypeDashboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>
>;
export type GetV8DashboardsViewTypeDashboardsQueryError = ErrorType<unknown>;

/**
 * @summary 기본뷰, 멀티뷰로 사용될 대시보드 아이디 조회
 */

export function useGetV8DashboardsViewTypeDashboards<
  TData = Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsViewTypeDashboards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsViewTypeDashboardsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
